import { ToastContainer } from '../../components/Common';
import DealerOrdersPage from './page';

const DealerOrdersPageWrapper = () => {
	return (
		<>
			<div className="page-content">
				<DealerOrdersPage />
			</div>
			<ToastContainer />
		</>
	);
};

export default DealerOrdersPageWrapper;
